import React from 'react';

interface Props {
  color?: string;
  size?: number;
  otherProps?: React.SVGProps<SVGSVGElement>;
}

const AppleIcon: React.FC<Props> = ({size, color}) => {
  return (
    <svg
      width={size ?? 15}
      height={size ? size + 4 : 19}
      viewBox="0 0 15 19"
      fill="none"
    >
      <path
        d="M5.134 18.704c-2.676-.015-4.89-5.478-4.89-8.26 0-4.545 3.41-5.54 4.723-5.54.593 0 1.225.232 1.783.438.39.144.793.292 1.017.292.134 0 .45-.126.73-.237.596-.237 1.337-.532 2.2-.532h.006c.644 0 2.599.142 3.774 1.906l.275.414-.396.299c-.566.427-1.598 1.206-1.598 2.749 0 1.827 1.169 2.53 1.73 2.868.249.149.505.303.505.64 0 .219-1.753 4.936-4.3 4.936-.622 0-1.062-.187-1.45-.352-.394-.168-.733-.311-1.293-.311-.284 0-.643.134-1.024.276-.519.194-1.107.414-1.774.414h-.018zM10.967.723c.066 2.39-1.643 4.05-3.351 3.945C7.334 2.76 9.323.723 10.967.723z"
        fill={color ?? "#fff"}
      />
    </svg>
  );
};

export default AppleIcon;
